import { BusinessUnitKey, type BusinessUnitConfig } from '@/modules/bu/bu.types';

// This product's entry in the BU registry, which discovers it by filename.
// Nothing outside this folder lists Cleepo: deleting the folder removes the
// product from the app.
export const config: BusinessUnitConfig = {
  key: BusinessUnitKey.Cleepo,
  order: 2,
  label: 'Cleepo',
  basePath: '/cleepo',
  domain: import.meta.env.VITE_APP_CLEEPO_URL,
  dashboardRouteName: 'CleepoDashboardView',
  loginRouteName: 'CleepoAuthLoginView',
  selectAccountRouteName: 'CleepoSelectAccountView',
  investRouteName: 'CleepoInvestView',
  websiteUrl: 'https://cleepo.ai',
  privacyPolicyUrl: 'https://engeni.com/privacy.html',
  chooserDescriptionKey: 'common.choose_business_unit_cleepo_description',
  cartSelectI18nPrefix: 'cleepo.cart_select',
  orbitPathTemplate: '/cleepo/project/:id/info',
  logoPath: '/images/cleepo-logo-green-blue.png',
  faviconPath: '/favicon/favicon-cleepo.ico',
};
